/**
 * @file rigorousCouseTaking.js
 * @author Jake Stark
 * @desc Rigourous Course Taking report plugin

*/

/**
 * @module rigorousCouseTaking
 * @desc rigorousCouseTaking report plugin
 */

define('plugins/rigorousCourseTaking',["underscore", "models",
    "cardboard/models", "cardboard/collections", "cardboard/util",
    "text!plugins/templates/rigorousCourseTaking_coursePatterns.html", "text!plugins/templates/rigorousCourseEnrollmentPSEO_table.html", "text!plugins/templates/rigorousCourseTaking_courseEnroll2_table.html", "text!plugins/templates/rigorousCourseTaking_courseExams.html",  
    "text!plugins/templates/rigorousCourseTaking_Intensity1.html", "text!plugins/templates/rigorousCourseTaking_Intensity2.html",
    "cardboard/pluginPieces"],
    function (_, SLEDSModels,
        CardboardModels, CardboardCollections, Util,
        coursePatternsTemplate, rigorousCourseEnrollmentPSEOTemplate, rigorousCourseEnrollmentABTemplate, rigorousCourseTakingExamsTemplate, intensityTemplate, intensityTemplate2,
        PluginPieces) {

        console.log("MODULE: rigorousCourseTaking");
        var colors = [Util.Color.gradients.blue1, Util.Color.gradients.green, Util.Color.gradients.blue2, Util.Color.gradients.grey2, Util.Color.gradients.purple, Util.Color.gradients.gold, Util.Color.gradients.blue3, Util.Color.gradients.cream];

        var tableClone, chartHeadClone;

        var $input = [];
        var tId, hc, nId, chartHeadId;
        var url;

        drill = function (options, chartId, event) {

            var myChart, myChartIndex;

            var tableCount = 0,
                chartHeads = 0,
                notes = 0;

            url = "/ibi_apps/WFServlet?IBIAPP_app=SLEDSwebsvc&IBIF_ex=sledsws_getdata_rigorouscoursetaking_drill.fex" + options;

            $.getJSON(url, function (json) {

                var chartData = [];

                if (json.dataSets) {
                    $.each($('.eec'), function (index, value) {
                        this.setAttribute("id", "" + tableCount + "");
                        ++tableCount;
                    });

                    $.each($('.chartHead'), function (index, value) {
                        this.setAttribute("id", "ch" + chartHeads + "");
                        ++chartHeads;
                    });

                    $.each($('.noteChart'), function (index, value) {
                        this.setAttribute("id", "note" + notes + "");
                        ++notes;
                    });

                    if (chartId) {
                        hc = "#" + chartId + "";
                        for (i = 0; i < charts.length; i++) {
                            if (charts[i].container.id == chartId)
                                myChart = i;
                        }
                    } else {
                        chartId = event.target.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.previousElementSibling.firstChild.id;

                        for (i = 0; i < charts.length; i++) {
                            if (charts[i].container.id == chartId)
                                myChart = i;
                        }
                        hc = "#" + charts[myChart].container.id + "";
                    }

                    charts[myChart].myChartTableId = charts[myChart].container.parentElement.nextSibling.children[1].id;

                    // charts[myChart].myChartHeadId = charts[myChart].container.parentElement.previousSibling.previousSibling.firstChild.id;

                    tId = "#" + charts[myChart].myChartTableId + "";
                    nId = "#note" + charts[myChart].myChartTableId + "";
                    //chartHeadId = "#" + charts[myChart].myChartHeadId + "";
                    // console.log(chartHeadId);

                    tableSave[charts[myChart].myChartTableId] = "<table id=" + charts[myChart].myChartTableId + " class='eec'>";

                    // chartHeadSave[charts[myChart].myChartTableId] = "<h5 id=" + charts[myChart].myChartHeadId + " class='chartHead'>" + $(chartHeadId)[0].innerHTML + "</h5>";

                    for (i = 0; i < charts[myChart].series[0].data.length; i++)
                        chartSave[i] = jQuery.extend(true, {}, charts[myChart].series[0].data[i]);

                    while (charts[myChart].series.length > 0)
                        charts[myChart].series[0].remove();
                    var data = json.dataSets.rigorousCourseEnrollmentPatternsDrill.data;

                    var tableContent = '<table id="' + charts[myChart].myChartTableId + '" class="eec"><thead><th>Program Combinations</th><th>Participation</th></thead>';

                    charts[myChart].options.plotOptions.column.colorByPoint = false;
                    charts[myChart].xAxis[0].update({
                        labels: {
                            enabled: false
                        }
                    });
                    charts[myChart].yAxis[0].update({
                        max: 100
                    });
                    charts[myChart].legend.options.enabled = true;

                    for (i = 0; i < data.length; i++) {
                        chartData = [];
                        chartData.push([data[i]['programName'], data[i]['percent']]);
                        tableContent += "<tr><th>" + data[i]['programName'] + "</th><td>" + data[i]['formattedCount'] + " (" + data[i]['formattedPercent'] + ")</td></tr>";
                        charts[myChart].addSeries({
                            stacking: "normal",
                            name: data[i]['programName'],
                            data: chartData,
                            color: colors[i],
                            dataLabels: false
                        }, false);
                    }
                    tableContent += "</table>";

                    tableClone = $(tId).clone();

                    tableSave[charts[myChart].myChartTableId] += tableClone[0].innerHTML + "</table>";

                    $(tId).replaceWith(tableContent);
                    $(nId).replaceWith("<div id=note" + charts[myChart].myChartTableId + "><p>NOTE: Click on Back button to return to previous chart. </p> </div>");
                    tableClone = $(tId).clone();

                    var myChartString = "'" + myChart + "'";

                    var button = '<input type="button" value="Back" class="backButton" id="backButton' + charts[myChart].myChartTableId + '" onclick="restoreEecReport(' + charts[myChart].chartId + ');"/>';

                    $input[myChart] = $(button);
                    $input[myChart].appendTo(hc);

                    //  chartHeadClone = $(chartHeadId).clone();
                    //      $(chartHeadId).replaceWith("<h5 id='" + charts[myChart].myChartHeadId + "' class='chartHead'>" + json.dataSets.earlyEducationAndCare.heading + "</h5>");
                    charts[myChart].render();

                } else {
                    alert(json.meta.dataNotAvailableMessage);
                }
            });
        };

        $("#progData").click(function () {
            window.workspace.setModalInfoDialogContent("  <p><strong>Child Care Assistance Program</strong>: (CCAP) helps make quality child care affordable by providing financial assistance to help families with low incomes pay for child care. <br/><a href='http://mn.gov/dhs/people-we-serve/children-and-families/economic-assistance/child-care/index.jsp' target='_blank'>Child Care Assistance Program  </a> </p>            <p><b>Early Childhood Family Education</b>: (ECFE) provides supports for all Minnesota families with children between the ages of birth to kindergarten entrance based on the idea that parents are a child's first and most important teachers. <a href='https://education.mn.gov/MDE/StuSuc/EarlyLearn/ECFE/index.html' target='_blank'>Early Childhood Family Education </a></p>                            <p><b>Early Childhood Special Education</b>: (ECSE) provides supports and services to infants, toddlers and preschool children with disabilities and their families.<br/>  <a href='https://education.mn.gov/MDE/EdExc/EarlyChildRes/EarlyChildSpecEd/index.html' target='_blank'>Early Childhood Special Education  </a></p>          <p><b>MN District Preschool</b>: program for children age three to kindergarten entrance with the purpose of preparing children to enter kindergarten. <br/><a href='https://education.mn.gov/MDE/SchSup/DataSubLogin/EarlyEducStudent/index.html' target='_blank'> Early Education Student </a> </p><p>                                        ECLDS charts start with Kindergarten cohorts and look back at previous program participation. As seen on the <a href='/#data' target='_blank'>Data Source Matrix</a>, Early Education Student is starting in the ECLDS with SFY14 cohort for ECFE and District Preschool. Kindergarten data is finalized the January following the end of the school year. June 2016 will be the first time that the SFY14 information for ECFE and District Preschool will be available in kindergarten cohort charts. June 2020 is the anticipated first time for a kindergartner's birth to five participation in ECFE and District Preschool (EE Student 17-18 cohort) will be reflected in kindergarten cohort information.   </p> ");
            Backbone.trigger('modalOpened');
            window.workspace.showModalInfoDialog();
        });

        restoreEecReport = function (myChartString) {

            var myChart = parseInt(myChartString);

            for (i = 0; i < charts.length; i++) {
                if (charts[i].chartId == myChart)
                    myChart = i;
            }

            var data = [];
            tId = "#" + charts[myChart].myChartTableId + "";
            nId = "#note" + charts[myChart].myChartTableId + "";

            chartHeadId = "#" + charts[myChart].myChartHeadId + "";

            $(nId).replaceWith("<div class='noteChart'>NOTE: Click on a program to see multiple program participation counts.</div>");

            $(tId).replaceWith(tableSave[charts[myChart].myChartTableId]);
            //  $(chartHeadId).replaceWith(chartHeadSave[charts[myChart].myChartTableId]);
            $input[myChart].remove();

            for (i = 0; i < chartSave.length; i++) {

                data.push({
                    name: chartSave[i]['name'],
                    y: chartSave[i]['y'],
                    x: chartSave[i]['x'],
                    color: chartSave[i]['color'],
                    allInfo: {
                        drillParm: chartSave[i]['allInfo']['drillParm']
                    }
                });
            }

            while (charts[myChart].series.length > 0)
                charts[myChart].series[0].remove();

            charts[myChart].legend.options.enabled = false;
            charts[myChart].yAxis[0].update({
                max: 50
            });
            charts[myChart].xAxis[0].update({
                labels: {
                    enabled: true
                }
            });
            charts[myChart].addSeries({
                type: "column",
                data: data,
                color: chartSave.colors,
                dataLabels: false
            }, false);
            charts[myChart].render();

        };

        var exports = {

            // options for the demo cats config. since this is a multi-select
            // report, we have to use a different view object, and tell it not to
            // show grades as categories.
            options: {
                orgDetailPane: false,
                noMapSearch: true,
                forcedSummaryFilters: ["rigorousCourseTakingCOHORTID"],
                // Show Filter definitions link at bottom of filter pane
                definitions: true
            },

            // each of these is the configuration that gets passed to a
            // DataBoxPaneView.
            panes: [
                {
                    title: "Rigorous Course Enrollment",
                     explanationText: "<p>This report shows the number and percent of graduates who enrolled in Postsecondary Enrollment Options (PSEO), Concurrent Enrollment, Advanced Placement (AP) courses, or International Baccalaureate (IB) courses while in high school. “N/A” means data was not available for the selected school or district.</p>",
                     openByDefault: true,
                    views: [
                        /* {
                             type: "template",
                             template: "PSEO / PSEC Concurrent"
                         },*/
                        {
                            // SETUP
                            // one glob = one line series
                            // in each series, one row = one data point
                            type: "column",
                            dataSourceName: "data",
                            dataSetPath: "rigorousCourseEnrollmentPSEO",

                            // "pointsWithinRows": given that the data is
                            // two-dimensional (meaning an array of arrays, or
                            // similar structure, implying that we have more than
                            // one series to plot) each series is contained in a
                            // "row", like so:
                            //	 +---------+
                            //	 | X X X X |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 +---------+
                            dataShape: "pointsAcrossRows",
                            dataDimensions: 2,

                            // DISPLAY
                            unitString: "%",
                            showLegend: true,
                           
                            // SERIES
                            // each series has two points, and is an organization
                            series: [
                                {
                                    seriesDisplayNamePath: "[0].orgs[0].name",
                                    values: [
                                        {
                                            valuePath: "[0].orgs[0].percent",
                                            pointLabelPath: "[0].type"
                                        },
                                        {
                                            valuePath: "[1].orgs[0].percent",
                                            pointLabelPath: "[1].type"
                                        },
                                        {
                                            valuePath: "[2].orgs[0].percent",
                                            pointLabelPath: "[2].type"
                                        }
                                    ]
                                },
                                {
                               
                                    seriesDisplayNamePath: "[0].orgs[1].name",
                                    values: [
                                        {
                                            valuePath: "[0].orgs[1].percent",
                                            pointLabelPath: "[0].type"
                                        },
                                        {
                                            valuePath: "[1].orgs[1].percent",
                                            pointLabelPath: "[1].type"
                                        },
                                        {
                                            valuePath: "[2].orgs[1].percent",
                                            pointLabelPath: "[2].type"
                                        }
                                    ]
                                },
                                {
                               
                                    seriesDisplayNamePath: "[0].orgs[2].name",
                                    values: [
                                        {
                                            valuePath: "[0].orgs[2].percent",
                                            pointLabelPath: "[0].type"
                                        },
                                        {
                                            valuePath: "[1].orgs[2].percent",
                                            pointLabelPath: "[1].type"
                                        },
                                        {
                                            valuePath: "[2].orgs[2].percent",
                                            pointLabelPath: "[2].type"
                                        }
                                    ]
                                },
                                  
                            ],
                            errorConditions: [PluginPieces.standardErrorCondition]
                        },
                        {
                            type: "template",
                            dataSourceName: "data",
                            dataSetPath: "rigorousCourseEnrollmentPSEO",
                            template: rigorousCourseEnrollmentPSEOTemplate,
                            /* errorConditions: [
                            {
                                valuePath: "data.data.science.data[0]",
                                is: undefined,
                                error: {
                                    type: "NoData",
                                    message: ""
                                }
                            }
                        ]*/
                                 errorConditions: [PluginPieces.silentStandardErrorCondition]
                        },
                        /* {
                            type: "template",
                            template: "AP / IB"
                        },*/

                        {
                            // SETUP
                            // one glob = one line series
                            // in each series, one row = one data point
                            type: "column",
                            dataSourceName: "data",
                            convertDataHashToArray: true,
                            dataSetPath: "rigorousCourseEnrollmentAPIB",

                            // "pointsWithinRows": given that the data is
                            // two-dimensional (meaning an array of arrays, or
                            // similar structure, implying that we have more than
                            // one series to plot) each series is contained in a
                            // "row", like so:
                            //	 +---------+
                            //	 | X X X X |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 +---------+
                            dataShape: "pointsAcrossRows",
                            dataDimensions: 2,

                            // DISPLAY
                            unitString: "%",
                            showLegend: true,
                           
                            // SERIES
                            // each series has two points, and is an organization
                            series: [
                                {
                                    seriesDisplayNamePath: "[0].orgs[0].name",
                                    values: [
                                        {
                                            valuePath: "[0].orgs[0].percent",
                                            pointLabelPath: "[0].type"
                                        },
                                        {
                                            valuePath: "[1].orgs[0].percent",
                                            pointLabelPath: "[1].type"
                                        },
                                        {
                                            valuePath: "[2].orgs[0].percent",
                                            pointLabelPath: "[2].type"
                                        }
                                    ]
                                },
                                {
                               
                                    seriesDisplayNamePath: "[0].orgs[1].name",
                                    values: [
                                        {
                                            valuePath: "[0].orgs[1].percent",
                                            pointLabelPath: "[0].type"
                                        },
                                        {
                                            valuePath: "[1].orgs[1].percent",
                                            pointLabelPath: "[1].type"
                                        },
                                        {
                                            valuePath: "[2].orgs[1].percent",
                                            pointLabelPath: "[2].type"
                                        }
                                    ]
                                },
                                {
                               
                                    seriesDisplayNamePath: "[0].orgs[2].name",
                                    values: [
                                        {
                                            valuePath: "[0].orgs[2].percent",
                                            pointLabelPath: "[0].type"
                                        },
                                        {
                                            valuePath: "[1].orgs[2].percent",
                                            pointLabelPath: "[1].type"
                                        },
                                        {
                                            valuePath: "[2].orgs[2].percent",
                                            pointLabelPath: "[2].type"
                                        }
                                    ]
                                },
                                  
                            ],
                           errorConditions: [PluginPieces.standardErrorCondition]
                        },
                        {
                            type: "template",
                            dataSourceName: "data",
                            dataSetPath: "rigorousCourseEnrollmentAPIB",
                            template: rigorousCourseEnrollmentABTemplate,
                            errorConditions: [PluginPieces.silentStandardErrorCondition]
                        },

                    ]

                }, {
                    title: "Rigorous Course Exams",
                    explanationText: "<p>This report shows the number and percent of graduates who took Advanced Placement or International Baccalaureate exams while in high school.</p>",
                    openByDefault: false,
                    views: [
                        /* {
                             type: "template",
                             template: "Rigorous Course Exams"
                            //templatePath: "rigorousCourseEnrollmentPSEO.heading"
                         },*/
                        {
                            // SETUP
                            // one glob = one line series
                            // in each series, one row = one data point
                            type: "column",
                            dataSourceName: "data",
                            convertDataHashToArray: true,
                            dataSetPath: "rigorousCourseExams",

                            // "pointsWithinRows": given that the data is
                            // two-dimensional (meaning an array of arrays, or
                            // similar structure, implying that we have more than
                            // one series to plot) each series is contained in a
                            // "row", like so:
                            //   +---------+
                            //   | X X X X |
                            //   | . . . . |
                            //   | . . . . |
                            //   | . . . . |
                            //   +---------+
                            dataShape: "pointsAcrossRows",
                            dataDimensions: 2,

                            // DISPLAY
                            unitString: "%",
                            showLegend: true,
                           
                            // SERIES
                            // each series has two points, and is an organization
                            series: [
                                {
                                    seriesDisplayNamePath: "[0].orgs[0].name",
                                    values: [
                                        {
                                            valuePath: "[0].orgs[0].percent",
                                            pointLabelPath: "[0].type"
                                        },
                                        {
                                            valuePath: "[1].orgs[0].percent",
                                            pointLabelPath: "[1].type"
                                        },
                                        {
                                            valuePath: "[2].orgs[0].percent",
                                            pointLabelPath: "[2].type"
                                        }
                                    ]
                                },
                                {
                               
                                    seriesDisplayNamePath: "[0].orgs[1].name",
                                    values: [
                                        {
                                            valuePath: "[0].orgs[1].percent",
                                            pointLabelPath: "[0].type"
                                        },
                                        {
                                            valuePath: "[1].orgs[1].percent",
                                            pointLabelPath: "[1].type"
                                        },
                                        {
                                            valuePath: "[2].orgs[1].percent",
                                            pointLabelPath: "[2].type"
                                        }
                                    ]
                                },
                                {
                               
                                    seriesDisplayNamePath: "[0].orgs[2].name",
                                    values: [
                                        {
                                            valuePath: "[0].orgs[2].percent",
                                            pointLabelPath: "[0].type"
                                        },
                                        {
                                            valuePath: "[1].orgs[2].percent",
                                            pointLabelPath: "[1].type"
                                        },
                                        {
                                            valuePath: "[2].orgs[2].percent",
                                            pointLabelPath: "[2].type"
                                        }
                                    ]
                                },
                                  
                            ],
                            errorConditions: [PluginPieces.standardErrorCondition]
                        },
                        {
                            type: "template",
                            dataSourceName: "data",
                            dataSetPath: "rigorousCourseExams",
                            template: rigorousCourseTakingExamsTemplate,
                            errorConditions: [PluginPieces.silentStandardErrorCondition]
                        },
                    ]
                },
                {
                    title: "Intensity",
                     explanationText: "<p>This report shows the number of Advanced Placement and International Baccalaureate exams and courses taken by graduates. “N/A” means data was not available for the selected school or district.</p>",
                    openByDefault: false,
                    views: [
                        /* {
                             type: "template",
                             template: "Rigorous Course Exams"
                            //templatePath: "rigorousCourseEnrollmentPSEO.heading"
                         },*/
                        {
                            // SETUP
                            // one glob = one line series
                            // in each series, one row = one data point
                            type: "column",
                            dataSourceName: "data",
                            convertDataHashToArray: true,
                            dataSetPath: "intensityExams",

                            // "pointsWithinRows": given that the data is
                            // two-dimensional (meaning an array of arrays, or
                            // similar structure, implying that we have more than
                            // one series to plot) each series is contained in a
                            // "row", like so:
                            //   +---------+
                            //   | X X X X |
                            //   | . . . . |
                            //   | . . . . |
                            //   | . . . . |
                            //   +---------+
                            dataShape: "pointsAcrossRows",
                            dataDimensions: 2,
                            yAxisMaxPath: "yAxisMax",
                            yAxisMinPath: "yAxisMin",

                            // DISPLAY
                            unitString: "",
                            showLegend: true,
                            xAxisLabelPath: "type",

                            // SERIES
                            // each series has two points, and is an organization
                            series: [
                                {
                                    valuePath: "orgs[0].countRange0",
                                    seriesDisplayName: "Range 0",
                                },
                                {
                                    valuePath: "orgs[0].countRange1to2",
                                    seriesDisplayName: "Range 1-2",
                                },
                                {
                                    valuePath: "orgs[0].countRange3to4",
                                    seriesDisplayName: "Range 3-4"
                                },
                                {
                                    valuePath: "orgs[0].countRange5to6",
                                    seriesDisplayName: "Range 5-6",
                                },
                                {
                                    valuePath: "orgs[0].countRange7Plus",
                                    seriesDisplayName: "Range 7+"
                                },

                            ],
                            errorConditions: [PluginPieces.standardErrorCondition]
                        },
                        {
                            type: "template",
                            dataSourceName: "data",
                            dataSetPath: "intensityExams",
                            template: intensityTemplate,
                                 errorConditions: [PluginPieces.silentStandardErrorCondition]
                        },
                          {
                            // SETUP
                            // one glob = one line series
                            // in each series, one row = one data point
                            type: "column",
                            dataSourceName: "data",
                            convertDataHashToArray: true,
                            dataSetPath: "intensityEnrollment",

                            // "pointsWithinRows": given that the data is
                            // two-dimensional (meaning an array of arrays, or
                            // similar structure, implying that we have more than
                            // one series to plot) each series is contained in a
                            // "row", like so:
                            //   +---------+
                            //   | X X X X |
                            //   | . . . . |
                            //   | . . . . |
                            //   | . . . . |
                            //   +---------+
                            dataShape: "pointsAcrossRows",
                            dataDimensions: 2,
                            yAxisMaxPath: "yAxisMax",
                            yAxisMinPath: "yAxisMin",

                            // DISPLAY
                            unitString: "",
                            showLegend: true,
                            xAxisLabelPath: "type",

                            // SERIES
                            // each series has two points, and is an organization
                            series: [
                                {
                                    valuePath: "orgs[0].countRange0",
                                    seriesDisplayName: "Range 0",
                                },
                                {
                                    valuePath: "orgs[0].countRange1to2",
                                    seriesDisplayName: "Range 1-2",
                                },
                                {
                                    valuePath: "orgs[0].countRange3to4",
                                    seriesDisplayName: "Range 3-4"
                                },
                                {
                                    valuePath: "orgs[0].countRange5to6",
                                    seriesDisplayName: "Range 5-6",
                                },
                                {
                                    valuePath: "orgs[0].countRange7Plus",
                                    seriesDisplayName: "Range 7+"
                                },

                            ],
                            errorConditions: [PluginPieces.standardErrorCondition]
                        },
                        {
                            type: "template",
                            dataSourceName: "data",
                            dataSetPath: "intensityEnrollment",
                            template: intensityTemplate2,
                                 errorConditions: [PluginPieces.silentStandardErrorCondition]
                        }
                        
                    ]
                },
                {
                    title: "Rigorous Course Enrollment Patterns",
                    visibleByDefault: true,
                    openByDefault: false,
                    explanationText: "<p>This report shows the number and percent of graduates participating in one or more rigorous course programs. AP and IB enrollment counts include students that transferred into the school or district. </p>",
                    views: [

                        {
                            type: "template",
                            template: "<div class='noteChart'><p>NOTE: Click on a program to see multiple program participation counts. </p></div>"
                        },
                        {
                            // SETUP
                            // all globs go into one series
                            // each glob has only one row = one data point
                            type: "column",
                            dataSourceName: "data",
                            dataSetPath: "rigorousCourseEnrollmentPatterns",
                            convertDataHashToArray: true,
                            //  yAxisMax: 60,
                            title: "",

                            // "pointsWithinRows": given that the data is
                            // two-dimensional (meaning an array of arrays, or
                            // similar structure, implying that we have more than
                            // one series to plot) each series is contained in a
                            // "row", like so:
                            //   +---------+
                            //   | X X X X |
                            //   | . . . . |
                            //   | . . . . |
                            //   | . . . . |
                            //   +---------+
                            dataShape: "pointsAcrossRows",

                            // since in this case there's only one dimension, due to
                            // there being only one series to plot, it looks like
                            // this:
                            //   +---------+
                            //   | X X X X |
                            //   +---------+
                            dataDimensions: 2,

                            // DISPLAY
                            // categoryFieldName: "entityType",
                            unitString: "%",
                            unitDec: 1,
                            disableLegendClick: true,
                          //  exportToPDF: true,
                          //  hideContext: true,
                            xAxisLabelPath: "type",
                            //  tooltipTemplate: "{{programName}}<br /><br />" + "<b>{{formattedPercent}} </b><br />",
                            colorByPoint: true,
                            showLegend: false,

                            // SERIES
                            series: [
                                {
                                    valuePath: "percent",
                                    //   seriesDisplayName: "Child Care Assistance Program (CCAP)",
                                    //     color: "orange"
                                }

                            ],
                              errorConditions: [PluginPieces.standardErrorCondition]
                        },
                        {
                            type: "template",
                            dataSourceName: "data",
                            dataSetPath: "rigorousCourseEnrollmentPatterns",
                            template: coursePatternsTemplate,
                                 errorConditions: [PluginPieces.silentStandardErrorCondition]
                        }
                    ]
                },
                {
                    title: "More Information",
                    visibleByDefault: true,
                    openByDefault: false,
                    views: [
                        {
                            type: "template",
                            template: "<p>Rigorous courses offer high school students the opportunity to earn college credits prior while in school through college-level classes. Such offerings include Advanced Placement (AP), International Baccalaureate (IB), Postsecondary Enrollment Options (PSEO) and Concurrent Enrollment programs. Rigorous course offerings vary by school and school district. Completion of rigorous courses is correlated to college enrollment and persistence through college. For more information on the courses and exams accepted for college credit at Minnesota colleges, please visit the Office of Higher Education's <a href='http://www.ohe.state.mn.us/sPages/collegeCreditHS.cfm' target='_blank'>Earned College Credit While in High School</a>.</p><p><a href='https://education.mn.gov/mdeprod/idcplg?IdcService=GET_FILE&dDocName=mde031880&RevisionSelectionMethod=latestReleased&Rendition=primary'>Download web report data</a> for all high schools and years. Please note this file does not include subgroup statistics. For more information, <a href='https://education.mn.gov/mdeprod/idcplg?IdcService=GET_FILE&dDocName=mde031756&RevisionSelectionMethod=latestReleased&Rendition=primary'>read the help document</a>.</p>"
                        }
                    ]
                }        
             ],

            filterSources: {
                orgs: {
                    modelType: SLEDSModels.SLEDSOrgList,
                    url: "/ibi_apps/WFServlet?IBIF_ex=sledsws_getdata_filter_hsgrad_orgid.fex",
                    noViewParams: true,
                    enabled: true
                },
                filters: {
                    modelType: CardboardModels.FilterData,
                    url: "/ibi_apps/WFServlet?IBIAPP_app=SLEDSwebsvc&IBIF_ex=sledsws_getdata_filter_ecodevregion.fex",
                    enabled: true
                },
                filters2: {
                    url: "/ibi_apps/WFServlet?IBIAPP_app=SLEDSwebsvc&IBIF_ex=sledsws_getdata_filter_rigorouscoursetaking_cohortid.fex",
                    enabled: true,
                    modelType: CardboardModels.FilterData
                },
              filters3: {
                    modelType: CardboardModels.FilterProducer,
                    filterSources: ["filterForReport"],
                    urls: {
                        filterForReport: "/ibi_apps/WFServlet?IBIAPP_app=SLEDSwebsvc&IBIF_ex=sledsws_getdata_filter_rigorouscoursetaking_dropdowns.fex"
                    },
                    enabled: true,
                }, 
                demographicCategories: {
                    modelType: CardboardCollections.DemoCatProducer,
                    url: "/ibi_apps/WFServlet?IBIAPP_app=SLEDSwebsvc&IBIF_ex=sledsws_getdata_filter_rigorouscoursetaking_buttons.fex",
                    enabled: true,
                    noViewParams: false
                }
            },
            dataSources: {
                data: {
                    // modelType: CardboardModels.Model,
                    modelType: CardboardModels.DocumentModel,
                  //   url: "/data/rigTest.json",
                   url: "/ibi_apps/WFServlet?IBIAPP_app=SLEDSwebsvc&IBIF_ex=sledsws_getdata_rigorouscoursetaking.fex",
                    yearPath: "dataYear",
                    defaultParams: {
                        orgId: 999999000
                    },
                    paramMappings: {
                        HSGRAD_ORGID: "orgId",
                        groupType: null, // skip this
                        //     COHORTID: "courseTakingCOHORTID",
                        orgName: null
                    },
                    postProcessor: function (data) {
                        // all we need to do is prettify all the org names!

                        var collectionsType1 = [
                        data.rigorousCourseEnrollmentPSEO.data,
                        data.rigorousCourseEnrollmentAPIB.data,
                        data.rigorousCourseExams.data,
                        data.intensityExams.data,
                        data.intensityEnrollment.data
                    ];

                        var collectionsType2 = [
                        
                    ];

                        _(collectionsType1).each(function (collection) {
                            _(collection).each(function (series) {
                                _(series.orgs).each(function (blob) {
                                    blob.name = Util.Data.prettifyName(blob.name);
                                });
                            });
                        });

                        _(collectionsType2).each(function (collection) {
                            _(collection).each(function (blob) {
                                blob.orgName = Util.Data.prettifyName(blob.orgName);
                            });
                        });
                    },

                    enabled: true,
                    /*errorConditions: [
                        {
                            valuePath: "errorMessage",
                            isNot: null,
                            error: {
                                type: "NoData",
                                message: "Sorry, we don't have any data for your selected school/district and year."
                            }
                        }
                    ]*/
                }
            }
        };

        return exports;
    });
